import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionGuard } from 'src/routes/components';
import { Resources } from '../resource';
import {
  Datagrid,
  FunctionField,
  InfiniteList,
  List,
  SelectInput,
  ShowButton,
  TextField,
  useTranslate,
} from 'react-admin';
import { DashboardContent } from 'src/layouts/dashboard';
import { Box, Card, Chip, Dialog, Typography } from '@mui/material';
import { EmptyContent } from 'src/components/empty-content';
import XDateField from '../../components/XDateField';
import AddressField from '../../components/AddressField';
import XTextField from '../../components/XTextField';
import FilterGroup from '../../components/FilterGroup';
import { useState } from 'react';

const categoryChoices = [
  { id: 'TransactionFee', name: 'Transaction Fee' },
  { id: 'WithdrawalTransfer', name: 'Withdrawal Transfer' },
  { id: 'LoginOrWalletConnection', name: 'Login Or Wallet Connection' },
  { id: 'Trading', name: 'Trading' },
  { id: 'CopyTrading', name: 'Copy Trading' },
  { id: 'AccountBalance', name: 'Account Balance' },
  { id: 'Other', name: 'Other' },
];

const UserFeedbackList = () => {
  const translate = useTranslate();
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'pending':
        return 'warning';
      case 'resolved':
        return 'success';
      case 'rejected':
        return 'error';
      default:
        return 'default';
    }
  };

  const feedbackFilters = [
    <FilterGroup alwaysOn>
      <SelectInput
        emptyText={'All'}
        source="category"
        choices={categoryChoices}
        label={translate('module.userFeedback.category')}
      />
    </FilterGroup>,
  ];

  return (
    <PermissionGuard resource="user-feedback" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('module.userFeedback.title')}
          links={[{ name: translate('module.userFeedback.title'), href: `${Resources.userFeedback}` }]}
        />
        <Card>
          <List
            filters={feedbackFilters}
            resource={Resources.userFeedback}
            empty={<EmptyContent />}
            exporter={false}
          >
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid bulkActionButtons={false} empty={<EmptyContent />}>
                <FunctionField
                  label="module.userFeedback.id"
                  render={(record: any) => <XTextField text={record.id} short />}
                />
                <TextField
                  source="category"
                  label="module.userFeedback.category"
                  sortable={false}
                />
                <TextField source="email" label="module.userFeedback.email" sortable={false} />
                <FunctionField
                  label={translate('module.userFeedback.feedback')}
                  render={(record: any) => <XTextField text={record.feedback} short copy={false} />}
                />
                <FunctionField
                  label="module.userFeedback.status"
                  render={(record: any) => (
                    <Chip
                      label={record.status}
                      color={getStatusColor(record.status)}
                      size="small"
                    />
                  )}
                  sortable={false}
                />

                <FunctionField
                  label="module.userFeedback.address"
                  render={(record: any) => <AddressField address={record.userAddress} />}
                />

                <FunctionField
                  label="module.userFeedback.attachments"
                  render={(record: any) => (
                    <Typography variant="caption">{record.cdnFileId?.length || 0} files</Typography>
                  )}
                  sortable={false}
                />

                <FunctionField
                  label="module.userFeedback.createdAt"
                  render={(record: any) => <XDateField value={record.createdAt} />}
                  sortable={false}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default UserFeedbackList;
